export const ENV = import.meta.env.VITE_ENV;
export const APP_NAME = import.meta.env.VITE_APP_NAME;
export const APP_DOMAIN = import.meta.env.VITE_APP_DOMAIN;
export const SUBSCRIPTION_SERVICE_URL = import.meta.env.VITE_SUBSCRIPTION_SERVICE_URL;
export const STRIPE_PUB_KEY = import.meta.env.VITE_STRIPE_PUB_KEY;
export const MATOMO_ID = import.meta.env.VITE_MATOMO_ID;
